import { useEffect, useState } from 'react';

import { fetchPortalUnreadCount } from '../api/feedback-journal.api';
import { isRouteAllowed } from '../../../shared/access/access';
import { useAuth } from '../../../shared/auth/use-auth';

/**
 * Бейдж непрочитанных ответов платформы в меню «Клиентский портал».
 * Только при наличии контекста организации; суперадмин без org бейдж не получает.
 */
export function usePortalUnreadBadge(): number {
  const { apiClient, me, impersonateOrgId } = useAuth();
  const [count, setCount] = useState(0);

  const effectiveOrgId =
    impersonateOrgId != null && impersonateOrgId > 0 ? impersonateOrgId : me?.organization_id ?? null;
  const enabled =
    me != null &&
    effectiveOrgId != null &&
    effectiveOrgId > 0 &&
    Boolean(me.capabilities && isRouteAllowed(me.capabilities, '/feedback'));

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const n = await fetchPortalUnreadCount(apiClient, effectiveOrgId);
        if (!cancelled) setCount(n);
      } catch {
        if (!cancelled) setCount(0);
      }
    };
    void load();
    const timer = setInterval(() => void load(), 60_000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [apiClient, effectiveOrgId, enabled]);

  return count;
}
